var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndoNone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.65626 1.01953V3.88406H12.5459C14.0183 3.88406 14.5091 4.36148 14.5091 5.79374V11.5228H12.5459V9.61311C12.5459 8.18085 12.0551 7.70343 10.5827 7.70343H6.65626V10.568L0.766602 5.79374L6.65626 1.01953Z",
    fill: "url(#paint0_linear_6999_47591)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.14712 0V3.40642H12.546C13.3094 3.40642 13.9745 3.52402 14.4268 3.964C14.8791 4.40397 15 5.05095 15 5.79353V12H12.0552V9.6129C12.0552 8.92321 11.9307 8.61534 11.7695 8.45854C11.6083 8.30174 11.2918 8.18063 10.5828 8.18063H7.14712V11.5871L0 5.79353L7.14712 0ZM1.53332 5.79353L6.16551 9.54842V7.22579H10.5828C11.3462 7.22579 12.0113 7.34339 12.4636 7.78337C12.9159 8.22334 13.0368 8.87031 13.0368 9.6129V11.0452H14.0184V5.79353C14.0184 5.10384 13.8939 4.79598 13.7327 4.63917C13.5715 4.48237 13.255 4.36126 12.546 4.36126H6.16551V2.03863L1.53332 5.79353Z",
    fill: "#626262"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6999_47591",
    x1: 7.63787,
    y1: 1.01953,
    x2: 7.63787,
    y2: 11.5228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4BBC9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoNone);
export default __webpack_public_path__ + "static/media/undo-none.3476fed25c9d3b5ad74d8e0fc1b3d1da.svg";
export { ForwardRef as ReactComponent };